import { render } from "./detail-header.vue?vue&type=template&id=3d36ba05&scoped=true&ts=true"
import script from "./detail-header.vue?vue&type=script&lang=ts"
export * from "./detail-header.vue?vue&type=script&lang=ts"

import "./detail-header.vue?vue&type=style&index=0&id=3d36ba05&lang=less&scoped=true"

import exportComponent from "/builds/workshop/teambition-frontend/node_modules/.pnpm/vue-loader@16.8.3_6zog4g7lmcedlfqueoidvwcx7q/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d36ba05"]])

export default __exports__